// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-accordion:hover {
  transform: scale(1.3);
  transition: 0.1s ease-in-out;
}

.text-module:hover {
  text-decoration: underline;
  color: #0056b3;
  cursor: pointer;
}

.text-module {
  transition: color 0.3s ease;
}

button.button-accordion {
  font-size: 1.2rem;
  padding: 0;
  display: flex;
  align-items: center;
}

h8.text-muted {
  font-size: 0.9rem;
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ModuleAccordion/AccordionItem.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".button-accordion:hover {\n  transform: scale(1.3);\n  transition: 0.1s ease-in-out;\n}\n\n.text-module:hover {\n  text-decoration: underline;\n  color: #0056b3;\n  cursor: pointer;\n}\n\n.text-module {\n  transition: color 0.3s ease;\n}\n\nbutton.button-accordion {\n  font-size: 1.2rem;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\nh8.text-muted {\n  font-size: 0.9rem;\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
